import { Injectable } from "@angular/core";
import { asapScheduler, BehaviorSubject, Observable } from "rxjs";
import { toSignal } from "@angular/core/rxjs-interop";

@Injectable({
  providedIn: "root",
})
export class SpinService {
  constructor() {}

  private _spinning$ = new BehaviorSubject<boolean>(false);
  spinning = toSignal(this._spinning$);

  nbDisabled = 0;

  get spinning$(): Observable<boolean> {
    return this._spinning$.asObservable();
  }

  spin(spin: boolean) {
    asapScheduler.schedule(() => {
      this._spinning$.next(spin);
    });
  }

  /*
  certains composants qui utilisent la route peuvent disable le canceler de requete pendant leurs durée de vie,
  ex: le multiCheckbox
   */
  disableCanceler() {
    this.nbDisabled++;
  }

  endDisableCanceler() {
    this.nbDisabled--;
  }
}
